var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container page"},[_c('content-db',{attrs:{"contentKey":_vm.theKey,"isCache":true},on:{"title-onset":function($event){_vm.contentTitle=$event}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }